import React from 'react'
import './Notice.scss'

const Notice = () => {
  return (
    <div className="notice-container">
      <div className="WordSection1">
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '23.0pt', lineHeight: '115%', color: '#312E2B' }}>
            Notice and Disclaimer
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            Effective date: November 23, 2022
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            THE INFORMATION PRESENTED HEREIN IS STRICTLY CONFIDENTIAL AND IS BEING PROVIDED TO YOU
            FOR INFORMATION PURPOSES ONLY. THIS PRESENTATION DOES NOT PURPORT TO BE ALL-INCLUSIVE OR
            NECESSARILY TO CONTAIN ALL THE INFORMATION THAT A PROSPECTIVE INVESTOR MAY DESIRE IN
            INVESTIGATING THE COMPANY, AND MAY BE SUBJECT TO UPDATING, WITHDRAWAL, REVISION OR
            AMENDMENT. NO REPRESENTATION OR WARRANTY, EXPRESS OR IMPLIED, IS OR WILL BE GIVEN BY THE
            COMPANY, THEIR ADVISERS OR ANY OF THEIR RESPECTIVE DIRECTORS, OFFICERS, SHAREHOLDERS,
            AFFILIATES OR EMPLOYEES AS TO THE ACCURACY OR COMPLETENESS OF THE PRESENTATION OR THE
            INFORMATION OR OPINIONS CONTAINED THEREIN.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            ANY FINANCIAL PROJECTIONS GIVEN ARE ILLUSTRATIVE ONLY AND NONE OF THE PROJECTIONS OR
            ASSUMPTIONS SHOULD BE TAKEN AS PROMISES ON THE PART OF THE COMPANY NOR SHOULD THEY BE
            TAKEN AS IMPLYING ANY INDICATION, ASSURANCE OR GUARANTEE THAT THOSE ASSUMPTIONS ARE
            CORRECT OR EXHAUSTIVE.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            THE FORWARD-LOOKING STATEMENTS IN THIS PRESENTATION ARE BASED ON CURRENT GOOD-FAITH
            ESTIMATES AND EXPECTATIONS AND ARE SUBJECT TO RISKS AND UNCERTAINTIES THAT COULD CAUSE
            ACTUAL RESULTS TO DIFFER MATERIALLY FROM THOSE EXPRESSED OR IMPLIED BY THOSE STATEMENTS.
            THERE CAN BE NO ASSURANCE THAT THE OBJECTIVES CONTAINED HEREIN WILL BE ACHIEVED. GIVEN
            THESE RISKS AND UNCERTAINTIES, POTENTIAL INVESTORS SHOULD NOT PLACE ANY RELIANCE ON
            FORWARD LOOKING STATEMENTS.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            EACH PROSPECTIVE INVESTOR MUST MAKE THEIR OWN INDEPENDENT ASSESSMENT OF THE INFORMATION
            PROVIDED BY THE COMPANY AND IS RECOMMENDED TO SEEK INDEPENDENT ADVICE ON THE CONTENTS
            HEREOF FROM AN AUTHORIZED PERSON SPECIALIZING IN ADVISING ON INVESTMENTS OF THE KIND IN
            QUESTION. NEITHER THE COMPANY, NOR ANY OF THEIR ADVISERS, NOR THEIR RESPECTIVE
            DIRECTORS, OFFICERS, AFFILIATES, CONSULTANTS OR EMPLOYEES SHALL BE LIABLE FOR ANY
            DIRECT, INDIRECT OR CONSEQUENTIAL LOSS OR DAMAGE SUFFERED BY ANY PERSON RELYING ON
            STATEMENTS OR OMISSIONS FROM THE PRESENTATION AND TO THE MAXIMUM EXTENT PERMITTED BY
            LAW, ALL CONDITIONS, WARRANTIES AND OTHER TERMS WHICH MIGHT BE IMPLIED BY STATUTE,
            COMMON LAW OR THE LAW OF EQUITY AND ANY SUCH LIABILITY ARE EXPRESSLY EXCLUDED.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            THE PRESENTATION DOES NOT CONSTITUTE AN OFFER TO SELL, WHICH IS ONLY DONE PURSUANT TO
            OFFERING DOCUMENTATION, AND DOES NOT FORM ANY COMMITMENT BY THE COMPANY TO PROCEED WITH
            AN INVESTMENT. THE COMPANY RESERVE THE RIGHT TO TERMINATE ANY DISCUSSIONS AND
            NEGOTIATIONS WITH ANY PROSPECTIVE INVESTORS AT ANY TIME AND WITHOUT GIVING ANY REASON.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            RISKS RELATED TO SECURITY OF OUR GAMING PLATFORM. HACKERS OR OTHER MALICIOUS GROUPS OR
            ORGANIZATIONS MAY ATTEMPT TO INTERFERE WITH THE CHESSX PLATFORM IN A VARIETY OF WAYS,
            INCLUDING, BUT NOT LIMITED TO, MALWARE ATTACKS, DENIAL OF SERVICE ATTACKS,
            CONSENSUS-BASED ATTACKS, SYBIL ATTACKS, SMURFING AND SPOOFING.&quot; SUCH ATTACKS MAY RESULT
            IN THEFT OF THE NFTS AND/OR THE REWARD TOKENS. THERE IS ALSO AN INHERENT RISK THAT THE
            SOFTWARE AND RELATED TECHNOLOGIES AND THEORIES THE COMPANY USES COULD CONTAIN
            WEAKNESSES, VULNERABILITIES OR BUGS (&quot;GLITCHES&quot;). GLITCHES COULD CAUSE, AMONG OTHER
            THINGS, COMPLETE LOSS OF THE NFTS PURCHASED BY USERS OR THE REWARD TOKENS EARNED BY
            USERS.
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '12.0pt',
            marginRight: '0in',
            marginBottom: '12.0pt',
            marginLeft: '0in'
          }}
        >
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            RISKS RELATED TO BLOCKCHAIN TECHNOLOGY.THE COMPANY&quot;S BUSINESS WILL BE DEPENDENT ON
            BLOCKCHAIN TECHNOLOGY, WHICH CARRIES CERTAIN RISKS. THE BLOCKCHAIN IS A
            DISINTERMEDIATING TECHNOLOGY THAT HAS THE POTENTIAL TO FACILITATE TRUST AND COMMERCE
            BETWEEN ECONOMIC ACTORS, WHETHER INDIVIDUALS OR COMPANIES. PUBLISHED IN 2008 BY SATOSHI
            NAKAMOTO, THE BITCOIN WHITE PAPER DESCRIBES A PAYMENT SYSTEM THAT ALLOWS INDIVIDUALS TO
            CONFIDENTLY TRANSACT WITH ONE ANOTHER WITHOUT KNOWING OR TRUSTING ONE ANOTHER AND
            WITHOUT INVOLVING A TRUSTED THIRD PARTY. BITCOIN WAS DESIGNED TO BE WITHOUT A CENTRAL
            POINT OF FAILURE AND SECURED BY CRYPTOGRAPHY AND MATHEMATICS, RATHER THAN TRUST IN A
            CENTRALIZED THIRD PARTY, FOR EXAMPLE. THIS CONCEPT OF A DECENTRALIZED ARCHITECTURE IS
            NOVEL AND INTENDED TO ALLOW INDIVIDUALS TO FREELY AND RAPIDLY TRANSACT WITH ONE ANOTHER
            REGARDLESS OF GEOGRAPHIC CONSTRAINTS. THE PHRASE &quot;SMART CONTRACT&quot; WAS COINED BY COMPUTER
            SCIENTIST NICK SZABO IN 1994 TO EMPHASIZE THE GOAL OF BRINGING WHAT HE CALLED THE
            &quot;HIGHLY EVOLVED&quot; PRACTICES OF CONTRACT LAW AND RELATED BUSINESS PRACTICES TO THE DESIGN
            OF ELECTRONIC COMMERCE PROTOCOLS ON THE INTERNET. PROPONENTS OF SMART CONTRACTS CLAIM
            THAT MANY KINDS OF CONTRACTUAL CLAUSES MAY THUS BE MADE PARTIALLY OR FULLY
            SELF-EXECUTING, SELF-ENFORCING OR BOTH. SMART CONTRACTS AIM TO PROVIDE SECURITY SUPERIOR
            TO TRADITIONAL CONTRACTS AND TO REDUCE OTHER TRANSACTION COSTS ASSOCIATED WITH
            CONTRACTING. SMART CONTRACTS IN THE FORM OF DIGITAL &quot;TOKENS&quot; LIKE THE TOKENS CAN NOW
            REPRESENT ANY TRADABLE ASSET. AS SUCH, DIGITAL TOKENS HAVE EMERGED AS A NEW ALTERNATIVE
            CHANNEL FOR COMPANIES TO RAISE FUNDS AND AS AN ENTIRELY NEW ASSET CLASS FOR INVESTORS.
            ACCORDINGLY, WHILE BUSINESSES BUILT ON BLOCKCHAIN-BASED TECHNOLOGY AND DIGITAL ASSETS
            MAY PRESENT INVESTMENT OPPORTUNITIES, THEY ALSO REQUIRE A HIGH DEGREE OF INVESTING
            SOPHISTICATION AND SPECIALIZATION AND DIFFERENTIATION BETWEEN WELL- AND POORLY-
            CONSTRUCTED OFFERINGS&quot;ESPECIALLY IN REGARDS TO UNDERLYING BUSINESS MODEL; TOKEN
            ECOSYSTEM FUNCTIONALITY; INCENTIVE ALIGNMENT; PRODUCT-MARKET FIT; TOKEN MARKET AND
            LIQUIDITY; AND LEGAL, REGULATORY AND FINANCIAL MECHANICS. IN THE CASE OF THE COMPANY,
            THE EXACT BUSINESS MODEL CONTINUES TO EVOLVE.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginTop: '12.0pt' }}>
          <span lang="EN" style={{ fontSize: '13.0pt', lineHeight: '115%', color: '#312E2B' }}>
            RISKS RELATED TO THE REGULATORY ENVIRONMENT.<b> </b>THE NFTS AND THE REWARD TOKENS (THE
            &quot;DIGITAL ASSETS&quot;) MAY BE DEEMED TO BE SECURITIES UNDER U.S. AND STATE SECURITIES LAWS
            AND LAWS OF OTHER JURISDICTIONS. THE NFTS ARE INTENDED TO BE VIRTUAL, CRYPTOGRAPHIC
            COLLECTIBLES. WE BELIEVE THEY ARE GOODS AND UTILITY TOKENS FOR USE AND CONSUMPTION AND
            PRESENT THE SAME USE CASE AND CONSUMPTIVE PURPOSE AS TRADING CARDS HAVE BEFORE. AS PART
            OF THAT EXPERIENCE, WE INTEND TO ALLOW THE NFTS TO BE PURCHASED AND SOLD ON CHESSX
            PLATFORM. IN OUR OPINION, THE BUYING AND SELLING OF THE NFTS, EVEN IN THE HOPE THAT THE
            PRICE WILL INCREASE, DOES NOT INVOLVE THE TRADING OF A SECURITY. TO DETERMINE WHETHER
            ANY OF THE DIGITAL ASSETS CONSTITUTE SECURITIES, THEY NEED TO BE ANALYZED AS &quot;INVESTMENT
            CONTRACTS&quot; UNDER THE U.S. SUPREME COURT&quot;S DECISION IN SEC V. W.J. HOWEY CO., 328 U.S.
            293 (1946) (&quot;HOWEY&quot;) AND ITS PROGENY. UNDER HOWEY, AN INSTRUMENT IS AN &quot;INVESTMENT
            CONTRACT&quot; AND, THUS, A SECURITY, IF THE PURCHASER MAKES AN INVESTMENT OF MONEY IN A
            COMMON ENTERPRISE WITH AN EXPECTATION OF PROFIT DERIVED PRIMARILY FROM THE
            ENTREPRENEURIAL OR MANAGERIAL EFFORTS OF OTHERS. WE DO NOT BELIEVE THE SALE OF NFTS OR
            THE NFTS THEMSELVES, NOR THE EARNING OF THE REWARD TOKENS OR THE REWARD TOKENS
            THEMSELVES CONSTITUTE AN INVESTMENT CONTRACT. IF THE DIGITAL ASSETS OR THE OFFER AND
            SALE OF THE DIGITAL ASSETS WERE DEEMED TO BE A SECURITY UNDER U.S. FEDERAL SECURITIES
            LAWS, THEN WE MAY BE REQUIRED TO REGISTER EACH ISSUANCE UNDER THE SECURITIES ACT OR RELY
            ON AN EXEMPTION THEREFROM. EITHER PROCESS WOULD RESULT IN SIGNIFICANT DELAYS AND COSTS
            THAT COULD REQUIRE THE COMPANY TO CEASE OPERATION OF CHESSX PLATFORM. IN ADDITION, THE
            COMPANY MAY BE SUBJECT TO PENALTIES FOR PROMOTING THE SALE OF UNREGISTERED SECURITIES.
            THE BUSINESS OF THE COMPANY IS SUBJECT TO COMPLEX AND EVOLVING U.S. AND OTHER FOREIGN
            LAWS AND REGULATIONS REGARDING PRIVACY, TECHNOLOGY, DATA PROTECTION AND OTHER MATTERS,
            MANY OF WHICH ARE SUBJECT TO CHANGE AND UNCERTAIN INTERPRETATION, AND COULD RESULT IN
            CLAIMS, CHANGES TO OUR BUSINESS PRACTICES, INCREASED COST OF OPERATIONS OR OTHERWISE
            HARM OUR BUSINESS. WE ARE SUBJECT TO A VARIETY OF ADDITIONAL LAWS AND REGULATIONS IN THE
            U.S. (INCLUDING NEW YORK&quot;S BIT LICENSE LAW) AND ABROAD THAT INVOLVE MATTERS CENTRAL TO
            OUR BUSINESS, INCLUDING USER PRIVACY, BLOCKCHAIN TECHNOLOGY, DATA PROTECTION AND
            INTELLECTUAL PROPERTY, AMONG OTHERS. THESE U.S. FEDERAL AND STATE AND FOREIGN LAWS AND
            REGULATIONS ARE CONSTANTLY EVOLVING AND CAN BE SUBJECT TO SIGNIFICANT CHANGE. IN
            ADDITION, THE APPLICATION AND INTERPRETATION OF THESE LAWS AND REGULATIONS ARE OFTEN
            UNCERTAIN, PARTICULARLY IN THE NEW AND RAPIDLY EVOLVING INDUSTRY IN WHICH WE OPERATE. WE
            PLAN ON ADOPTING POLICIES AND PROCEDURES DESIGNED TO COMPLY WITH THESE LAWS AND
            REGULATIONS IN THE U.S. AND ABROAD. THE RISK OF THE COMPANY BEING FOUND IN VIOLATION OF
            THESE OR OTHER LAWS AND REGULATIONS (BOTH THE U.S. AND ABROAD) IS FURTHER INCREASED BY
            THE FACT THAT MANY OF THEM HAVE NOT BEEN FULLY INTERPRETED BY THE REGULATORY AUTHORITIES
            OR THE COURTS AND ARE OPEN TO A VARIETY OF INTERPRETATIONS. ANY ACTION BROUGHT AGAINST
            US FOR VIOLATION OF THESE OR OTHER LAWS OR REGULATIONS, EVEN IF WE SUCCESSFULLY DEFEND
            AGAINST IT, COULD CAUSE US TO INCUR SIGNIFICANT LEGAL EXPENSES AND DIVERT OUR
            MANAGEMENT&quot;S ATTENTION FROM THE OPERATION OF OUR BUSINESS. IF OUR OPERATIONS ARE FOUND
            TO BE IN VIOLATION OF ANY OF THESE LAWS AND REGULATIONS, WE MAY BE SUBJECT TO ANY
            APPLICABLE PENALTY ASSOCIATED WITH THE VIOLATION, INCLUDING CIVIL AND CRIMINAL
            PENALTIES, DAMAGES AND FINES, WE COULD BE REQUIRED TO REFUND PAYMENTS RECEIVED BY US,
            AND WE COULD BE REQUIRED TO CURTAIL OR CEASE OUR OPERATIONS OR MODIFY OUR PRACTICES,
            PROCEDURES OR FEATURES OF THE CHESSX PLATFORM. ANY OF THE FOREGOING CONSEQUENCES COULD
            SERIOUSLY HARM OUR BUSINESS AND ITS FINANCIAL RESULTS. THESE EXISTING AND PROPOSED LAWS
            AND REGULATIONS CAN BE COSTLY TO COMPLY WITH AND CAN DELAY OR IMPEDE THE DEVELOPMENT OF
            NEW PRODUCTS AND WORK ON THE CHESS X PLATFORM, RESULT IN NEGATIVE PUBLICITY, INCREASE
            OUR OPERATING COSTS, REQUIRE SIGNIFICANT MANAGEMENT TIME AND ATTENTION, AND SUBJECT US
            TO CLAIMS OR OTHER REMEDIES, INCLUDING FINES OR DEMANDS THAT WE MODIFY OR CEASE EXISTING
            BUSINESS PRACTICES.
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN">&nbsp;</span>
        </p>
      </div>
    </div>
  )
}

export default Notice
